const styleKey = {
  hide: "hide"
  ,toastPrimary: "toastPrimary"
  ,toastSuccess: "toastSuccess"
  ,toastWarning: "toastWarning"
  ,toastError: "toastError"
  ,inputButtonPrimary: "inputButtonPrimary"
  ,inputButtonSuccess: "inputButtonSuccess"
  ,inputButtonWarning: "inputButtonWarning"
  ,inputButtonError: "inputButtonError"
}
export default styleKey



// WEBPACK FOOTER //
// ./src/cnConst/styleKey.js